document.addEventListener('DOMContentLoaded', function () {
    var containers = document.querySelectorAll('[data-filter-container]');

    containers.forEach(function (container) {
        var filters = container.querySelectorAll('[data-filter]');
        var items = container.querySelectorAll('[data-categories]');

        filters.forEach(function (btn) {
            btn.addEventListener('click', function () {
                filters.forEach(function (b) { b.classList.remove('active'); });
                btn.classList.add('active');

                var filter = btn.getAttribute('data-filter');

                items.forEach(function (item) {
                    if (filter === 'all') {
                        item.style.display = '';
                    } else {
                        var cats = item.getAttribute('data-categories') || '';
                        item.style.display = cats.split(' ').indexOf(filter) !== -1 ? '' : 'none';
                    }
                });
            });
        });
    });
});
